
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'
import COVERAPP from '@/utils/COVERAPP'
import InfoModal from '@/components/InfoModal.vue'
import FlopModal from '@/components/FlopModal.vue'
import RandomModal from '@/components/RandomModal.vue'

@Options({
    components: { 
        InfoModal,
        FlopModal,
        RandomModal
     },
    computed: {
        ...mapState(['userInfo', 'aid', 'activityData'])
    },
    data() {
        return {
            isApp: false,
            isDisabled: false,
            showInfoModal: false,
            detail: {},
            textCount: {
                total: 0,
                surplus: 0,
            },
            showRandomModal: false,
            showFlopModal: false,
            modalData: {
                // state: 1,
                // amount: 68,
                // name: "春节随机红包",
                // pid: "63b4f7d48cda5c252bb74fb5",
            },
        }
    },
    mounted() {
        this.getCount()

        const {index} = this.$route.query
        this.detail = this.activityData.templateConfig.goods_list[index || 0] || {}
        
        this.isApp = COVERAPP.Attribute.isApp()

        this.$common.pageLoaded()
        this.$common.track('load', '进入详情页')
    },
    methods: {
        ...mapMutations(["SET_DIALOGDATA", "SET_HBDATA"]),
        closeModal() {
            this.$router.replace('/recordfu')
            this.showFlopModal = false
            this.showRandomModal = false
        },
        openClick() {
            if(this.modalData.pid === 'noPid') {
                return this.modalData.state = 2
            }
            this.$request('/lottery/cash', {
                aid: this.aid,
                pid: this.modalData.pid
            }, 'put', this.closeModal).then((data: any) => {
                this.modalData.state = 2
                this.$toast(`${this.modalData.amount}元提现成功`)
            }).catch((res: any) => {
                if (res && res.errno == 1001 && res.errmsg == 'V2_ACCOUNT_SIMPLE_BAN') {
                    this.SET_DIALOGDATA({
                        text: '您的微信未实名认证，不能领取红包，请实名认证后领取',
                        btns: [
                            {
                                text: '确定'
                            }
                        ]
                    })
                    this.showModal = false
                } else if (!res || !res.errno || (res.errno && res.errno != 1250 && res.errno != 1010)) {
                    this.$toast('加载失败，请重试！')
                }
            })
        },
        closeInfo() {
            this.showInfoModal = false;
            this.$router.replace('/recordfu')
        },
        submitInfo(info: any) {
            this.showInfoModal = false;
            this.$toast.loading('加载中')
            this.$request('/temporary/2023redpack/address', {
                pid: this.modalData.pid,
                info: info,
            }, 'post').then((data: any) => {
                this.$toast('您的兑奖联系方式已提交成功。')
            }).catch((err: any) => {
                this.$toast.clear()
            })
        },
        getCount() {
            this.$request('/temporary/2023redpack/count', {
                aid: this.aid,
                userinfo: this.userInfo,
            }, 'post').then((data: any) => {
                this.textCount = {
                    total: data.total,
                    surplus: data.surplus,
                }
            }).catch((err: any) => {
                this.$toast(err.errmsg || '出错了')
            })
        },
        exchangeClick() {
            this.SET_DIALOGDATA({
                text: `兑换当前礼品需花费${this.detail.number}个“福”，确认是否兑换？`,
                btns: [
                    {
                        text: '取消',
                        className: 'cancel-btn'
                    },
                    {
                        text: '确定',
                        callback: () => {
                            // 翻牌红包
                            if(this.detail.type === 'flop') this.exchangeFlop() ;
                            // 随机红包、实物
                            else this.exchangeReq()
                        }
                    }
                ]
            })
        },
        exchangeReq() {
            this.$request('/temporary/2023redpack/exchange', {
                aid: this.aid,
                userinfo: this.userInfo,
                type: this.detail.type,
            }, 'post').then((data: any) => {
                if(this.detail.type !== 'random') this.showInfoModal = true
                else  {
                    this.modalData = {
                        ...data,
                        state: 1,
                        type: this.detail.type,
                        amount: data.amount ? (data.amount / 100).toFixed(2) : 0,
                    }
                   this.showRandomModal = true
                }
                this.getCount()
            }).catch((err: any) => {
                if(err.errno === 1002) err.errmsg = '亲，您要兑换的商品已被抢光，去兑换其他商品吧。'
                if(err.errno === 1003) err.errmsg = '亲，您的兑换次数已用完，去试试写福字抽取现金包吧。'
                this.failModal(err)
            })
        },
        exchangeFlop() {
            this.$request('/temporary/2023redpack/flop', {
                aid: this.aid,
                userinfo: this.userInfo,
                type: this.detail.type,
            }, 'post').then((data: any) => {
                if(!data || !data.pid) {
                    // 未中奖
                    this.modalData = {
                        pid: 'noPid',
                        amount: 0,
                        state: 1,
                        type: this.detail.type,
                    }
                }else {
                    this.modalData = {
                        ...data,
                        state: 1,
                        type: this.detail.type,
                        amount: data.amount ? (data.amount / 100).toFixed(2) : 0,
                    }
                }
                this.showFlopModal = true
                this.getCount()
            }).catch((err: any) => {
                if(err.errno === 1003) err.errmsg = '亲，您的兑换次数已用完，去试试写福字抽取现金包吧。'
                this.failModal(err)
            })
            
        },
        failModal(err: any) {
            this.SET_DIALOGDATA({
                text: err.errmsg || '出错了',
                btns: [
                    {
                        text: '确定',
                        callback: () => {
                            this.showFlopModal = false
                            this.showRandomModal = false
                        }
                    }
                ]
            })
        },
    }
})
export default class Detail extends Vue { }
